import { Action } from '@ngrx/store'

/**
 * Created by sange on 17/08/2017.
 */

export const SELECT_MENU_ITEM = '[Menu] select item'

export class SelectMenuItem implements Action {
  readonly type = SELECT_MENU_ITEM

  constructor(public payload: string) {
  }
}

export type Actions =
  SelectMenuItem




// WEBPACK FOOTER //
// ./src/app/shared/navbar/menu/store/actions/menu.actions.ts